import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../hooks/useWindowResize";
import { size } from "../../../constants";
import ContactSectionForm from "../../../components/ContactSectionForm";
import styled from "styled-components";

const StylesWrapper = styled.div`
  .contact-wrapper {
    .container-blog {
      max-width: unset;
    }
  }
`;

export const Contact = () => {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const isMobile = width <= size.tablet;

	return (
		<StylesWrapper>
			<div className="contact-wrapper">
				<ContactSectionForm title={t("contactUs.title")} isMobile={isMobile} />
			</div>
		</StylesWrapper>
	);
};
